<template lang="pug">
  .table-responsive
    table#tbProveedores.table.is-striped.is-fullwidth
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6
            | Proveedor
          th.is-size-6
            | Dirección
          th.is-size-6
            | Contacto
      tbody
        tr(v-for="(prov, index) in proveedores" :key="prov.id")
          td
            a.button.is-black.is-rounded.is-small(@click="editarProveedor(prov)")
              | {{ index + 1 }}
          td(v-html="convertirReferencias(prov)")
            span.tag.is-black
              | {{ prov.nombre }}
            .tags.has-addons.is-top
              span.tag.is-info R.F.C.
              span.tag {{ prov.rfc }}
          td(v-html="convertDireccion(prov)")
          td(v-html="convetirContacto(prov)")
</template>

<script>
  export default {
    name: 'Tb_ProveedoresPendientes',
    props: {
      proveedores: {
        type: Array,
        default: []
      },
    },

    methods: {
      editarProveedor(prov) {
        this.$emit('editarProv', prov)
      },
      convertDireccion(dir) {

        const _calleLenght = dir.calle.length + dir.numExt.length + dir.colonia.length + dir.ciudad.length
        const _estadoLenght = dir.pais.length + dir.cp.length + dir.telefono1.length
        const data = _calleLenght + _estadoLenght
        if (data > 0) {
          const calleHTML = `${dir.calle === '' ? '' : `${dir.calle}, `}`
          const numExtHTML = `${dir.numExt === '' ? '' : `#${dir.numExt}, `}`
          const coloniaHTML = `${dir.colonia === '' ? '' : `${dir.colonia}, `}`
          const ciudadHTML = `${dir.ciudad === '' ? '' : `${dir.ciudad}`}`

          const estadoHTML = `${dir.estado === '' ? '' : `${dir.estado}`}`
          const paisHTML = `${dir.pais === '' ? '' : `${dir.pais}`}`
          const cpHTML = `${dir.cp === '' ? '' : `${dir.cp}`}`
          const telefonoHTML = `${dir.telefono1 === '' ? '' : `${dir.telefono1}`}`
  
          let html = `<small>${calleHTML}${numExtHTML}${coloniaHTML}${ciudadHTML}</small><br />
          <small>${estadoHTML}, ${paisHTML} ~ C.P. ${cpHTML} ~ Tel. ${telefonoHTML}</small>
          `
          return html
        } else {
          return ''
        }
      },
      convetirContacto(dir) {
        const contactoHTML = dir.contacto !== '' ? `<span class="tag is-dark">${dir.contacto}</span><br />` : ''
        const correoHTML = dir.correo !== '' ? `<a href="mailto:${dir.correo}">${dir.correo}&nbsp<i class="far fa-envelope"></i></a>` : ''
        let html = `${contactoHTML}${correoHTML}`
        return html
      },
      convertirReferencias(dir) {
        const nombreHTML = dir.nombre === '' ? '' : `<div class="control"><span class="tag is-black">${dir.nombre}</span></div>`
        const rfcHTML = dir.rfc === '' ? '' : `<div class="control is-tag-top">
              <div class="tags has-addons">
                <span class="tag">R.F.C.</span>
                <span class="tag">${dir.rfc}</span>
              </div>
            </div>`
        const cableInterHTML = dir.clabeInterbancaria !== '' ? `<div class="control is-tag-top">
              <div class="tags has-addons">
                <span class="tag">CLABE:</span>
                <span class="tag">${dir.clabeInterbancaria}</span>
              </div>
            </div>` : ''
        const bancoHTML = dir.banco !== '' ? `<div class="control is-tag-top">
              <span class="tag is-dark">${dir.banco}</span>
            </div>` : ''

        let html = `${nombreHTML}${rfcHTML}${cableInterHTML}${bancoHTML}`
        return html
      },
    },
  }
</script>

<style lang="css" scoped>
  .control .is-tag-top {
    margin-top: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbProveedoresPend.vue